module.exports = __webpack_public_path__ + "entry-150bfe9b/background-3dc4b04830ff7cf6945938d9c6ad8d63.svg";